export default __webpack_public_path__ + "static/media/plus.7faf770f.svg";